import type { AuditLog } from "@/mocks/configuracoes";
import SettingsStatusBadge from "./SettingsStatusBadge";

interface AuditDetailDrawerProps {
  log: AuditLog;
  onClose: () => void;
}

export default function AuditDetailDrawer({ log, onClose }: AuditDetailDrawerProps) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative bg-white w-full max-w-lg h-full overflow-y-auto shadow-xl">
        <div className="sticky top-0 bg-white border-b border-background-200/70 px-6 py-4 flex items-center justify-between z-10">
          <h3 className="text-base font-semibold text-foreground-900 font-heading">Detalhe do Log de Auditoria</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-foreground-600 transition-colors">
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <div className="p-6 space-y-5">
          <div className="flex items-center justify-between">
            <span className="text-xs text-foreground-500">ID: {log.id}</span>
            <SettingsStatusBadge status={log.status} />
          </div>

          <div className="space-y-3">
            <DetailRow label="Data/Hora" value={log.datetime} icon="ri-calendar-line" />
            <DetailRow label="Usuário" value={log.user} icon="ri-user-line" />
            <DetailRow label="Ação" value={log.action} icon="ri-play-circle-line" />
            <DetailRow label="Módulo" value={log.module} icon="ri-folder-line" />
            <DetailRow label="Entidade" value={log.entity} icon="ri-file-text-line" />
            <DetailRow label="Descrição" value={log.description} icon="ri-chat-1-line" />
            <DetailRow label="IP / Dispositivo" value={log.ip} icon="ri-computer-line" />
          </div>

          <div className="bg-secondary-50 border border-secondary-200 rounded-xl p-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                <i className="ri-information-line text-secondary-600 text-lg" />
              </div>
              <div>
                <p className="text-xs font-semibold text-secondary-800 mb-1">Informação de auditoria</p>
                <p className="text-xs text-secondary-600">
                  Este registro foi gerado automaticamente pelo sistema de auditoria do FloraIQ.
                  Os dados de IP e dispositivo são simulados nesta versão mockada.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-background-200/70 px-6 py-4 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold text-foreground-600 bg-background-50 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap">Fechar</button>
        </div>
      </div>
    </div>
  );
}

function DetailRow({ label, value, icon }: { label: string; value: string; icon: string }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center shrink-0">
        <i className={`${icon} text-foreground-500 text-sm`} />
      </div>
      <div className="min-w-0">
        <p className="text-xs text-foreground-400">{label}</p>
        <p className="text-sm text-foreground-900">{value}</p>
      </div>
    </div>
  );
}